import { render, staticRenderFns } from "./AppHeader--Landscape.vue?vue&type=template&id=a4a5670a&lang=pug&"
import script from "./AppHeader--Landscape.vue?vue&type=script&lang=js&"
export * from "./AppHeader--Landscape.vue?vue&type=script&lang=js&"
import style0 from "./AppHeader--Landscape.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports